import React from 'react';
import HeroFeature from 'components/partials/page_headers/hero-feature';

// import types
import { HeroContent } from "types/hero-content";
import { VideoData } from 'types/video-data';

// import helpers
import { isGatsbyImageData } from "helpers/is-gatsby-image";
import { getLinkDataFromDato } from "helpers/get-link-data";

const HeroFeatureComponentBuilder: React.FC<{ heroData?: Queries.HeroImageBlockFragment }> = ({ heroData }) => {

    if (!heroData) return null;

    const linkData = getLinkDataFromDato(heroData.link?.link);

    const heroContentMain = {
        id: heroData.id || '',
        label: heroData.label || '',
        title: heroData.heading || '',
        subtext: heroData.text || '',
        link: linkData?.url || '',
        linkLabel: linkData?.label || '',
        target: linkData?.target || '_self'
    };

    const heroCards = heroData.textCards?.map( (card): HeroContent | undefined => {
        if (!card) return undefined; // Skip if card is falsy

        const linkData = getLinkDataFromDato(card.link?.link);

        return {
            id: card.id || '',
            label: card.label || '',
            title: card.title || '',
            subtext: card.text || '',
            link: linkData?.url || "",
            target: linkData?.target || "_self"
        };
    }).filter((card): card is HeroContent => card !== undefined) || [];

    let heroImage = undefined;
    let heroImageAlt = '';
    if (heroData.media && typeof heroData.media === 'object') {
        // The image size we need is determined by whether the hero component will show cards or not
        if (heroCards.length > 0 && heroData.imageOnly === false) {
            heroImage = isGatsbyImageData(heroData.media?.gatsbyImageData) ? heroData.media?.gatsbyImageData : undefined;
        } else {
            heroImage = isGatsbyImageData(heroData.media?.gatsbyImageDataNoCardsSize) ? heroData.media?.gatsbyImageDataNoCardsSize : undefined;
        }

        heroImageAlt = heroData.media.alt || '';
    }

    let heroVideo = undefined;

    // TODO: Should we add a posterUrl? Dato doesn't create one from a video file.
    if (heroData.media && typeof heroData.media === 'object' && heroData.media.isImage === false) {
        heroVideo = {
            url: heroData.media.url || '',
            posterUrl: '',
            type: `video/${heroData.media.format || 'mp4'}`
        } as VideoData;
    }

    return (
        <HeroFeature
            imageOnly={heroData.imageOnly || false}
            heroContentMain={heroContentMain}
            heroCards={heroCards}
            heroImage={heroImage}
            heroImageAlt={heroImageAlt}
            heroVideo={heroVideo}
        />
    );
};

export default HeroFeatureComponentBuilder;